const units = ['KB', 'MB', 'GB'];

const numberFormatter = new Intl.NumberFormat('en-US', {
  maximumFractionDigits: 2,
});

export const bytesToLiteral = (kb: number) => {
  const [amount, unit] = units.reduce(
    (acc, unit) => {
      if (acc[0] > 1024) {
        return [acc[0] / 1024, unit];
      }

      return acc;
    },
    [kb, 'KB']
  );

  return `${numberFormatter.format(amount)} ${unit}`;
};
